var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fine-edit-modal" },
    [
      _c(
        "c-sidesheet",
        {
          attrs: { active: _vm.displayModal },
          on: { close: _vm.onReset, shown: _vm.onModalOpening },
        },
        [
          _vm.displayModal
            ? _c(
                "div",
                {
                  staticClass: "fines-and-bonuses-create-modal edit-modal",
                  class: { "editing-mode": _vm.id },
                },
                [
                  _c(
                    "div",
                    { staticClass: "fines-and-bonuses-create-modal__title" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.id
                              ? `Редактирование ${
                                  _vm.createFineOrBonus === "fine"
                                    ? "штрафа"
                                    : "премии"
                                }`
                              : "Добавление штрафа/премии"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "fines-and-bonuses-create-modal__row" },
                    [
                      _c(
                        "div",
                        { staticClass: "fines-and-bonuses-create-modal__item" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fines-and-bonuses-create-modal__worker",
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "fines-and-bonuses-create-modal__worker-photo",
                                attrs: {
                                  src: `${
                                    _vm.worker.photo
                                      ? _vm.worker.photo
                                      : "/redesign/img/userpic.svg"
                                  }`,
                                  alt: "",
                                  width: "34",
                                  height: "34",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fines-and-bonuses-create-modal__worker-text",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fines-and-bonuses-create-modal__worker-name",
                                    },
                                    [_vm._v(_vm._s(_vm.worker.name))]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fines-and-bonuses-create-modal__worker-posts",
                                    },
                                    [_vm._v(_vm._s(_vm.worker.posts))]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fines-and-bonuses-create-modal__worker-filial",
                                    },
                                    [_vm._v(_vm._s(_vm.worker.filial))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  !_vm.id
                    ? _c(
                        "div",
                        { staticClass: "fines-and-bonuses-create-modal__row" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fines-and-bonuses-create-modal__item",
                            },
                            [
                              _c("c-switcher", {
                                staticClass: "h-switcher",
                                class: {
                                  "green-outline":
                                    _vm.createFineOrBonus === "bonus",
                                },
                                attrs: {
                                  type: "group",
                                  items: [
                                    { label: "Штраф", value: "fine" },
                                    { label: "Премия", value: "bonus" },
                                  ],
                                },
                                model: {
                                  value: _vm.createFineOrBonus,
                                  callback: function ($$v) {
                                    _vm.createFineOrBonus = $$v
                                  },
                                  expression: "createFineOrBonus",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "fines-and-bonuses-create-modal__row" },
                    [
                      _c(
                        "div",
                        { staticClass: "fines-and-bonuses-create-modal__item" },
                        [
                          _c("c-select", {
                            class: {
                              "required-field": _vm.errorMessages.fineOrBonus,
                            },
                            attrs: {
                              type: "select",
                              "floating-label": `Причина ${
                                _vm.createFineOrBonus === "bonus"
                                  ? "премии"
                                  : "штрафа"
                              }`,
                              "required-mark": true,
                              clearable: true,
                              searchable: true,
                              groups: _vm.fineOrBonusSelectGroups,
                              items:
                                _vm.createFineOrBonus === "bonus"
                                  ? _vm.bonusesCollection.items
                                  : _vm.finesCollection.items,
                              required: _vm.errorMessages.fineOrBonus,
                              "required-condition":
                                _vm.errorMessages.fineOrBonus,
                            },
                            model: {
                              value: _vm.form.fineOrBonus,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "fineOrBonus", $$v)
                              },
                              expression: "form.fineOrBonus",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "fines-and-bonuses-create-modal__item" },
                        [
                          _vm.createFineOrBonus === "fine"
                            ? _c("show-description", {
                                staticClass: "show-description",
                                attrs: {
                                  value:
                                    _vm.form.fineOrBonus &&
                                    _vm.form.fineOrBonus.value,
                                  list: _vm.fineDescriptions,
                                  type: "mini",
                                },
                              })
                            : _vm._e(),
                          _vm.createFineOrBonus === "bonus"
                            ? _c("show-description", {
                                staticClass: "show-description",
                                attrs: {
                                  value:
                                    _vm.form.fineOrBonus &&
                                    _vm.form.fineOrBonus.value,
                                  list: _vm.bonusDescriptions,
                                  type: "mini",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "fines-and-bonuses-create-modal__row" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "fines-and-bonuses-create-modal__item amount-input",
                          class: { "no-flex-grow": _vm.id },
                        },
                        [
                          _c("c-input", {
                            class: {
                              "required-field": _vm.errorMessages.amount,
                            },
                            attrs: {
                              label: "Сумма, ฿",
                              placeholder: "0",
                              "required-mark": true,
                              clearable: true,
                              type: "integer-number",
                              required: _vm.errorMessages.amount,
                              "required-condition": _vm.errorMessages.amount,
                              "max-length": 12,
                            },
                            model: {
                              value: _vm.form.amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "amount", $$v)
                              },
                              expression: "form.amount",
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.id
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "fines-and-bonuses-create-modal__item date-input",
                            },
                            [
                              _c("c-input", {
                                staticClass: "date-container-sm-fix",
                                class: {
                                  "required-field": _vm.errorMessages.date,
                                },
                                attrs: {
                                  type: "date",
                                  placeholder: "00.00.0000",
                                  label: `Дата ${
                                    _vm.createFineOrBonus === "bonus"
                                      ? "премии"
                                      : "штрафа"
                                  }`,
                                  "icon-right": true,
                                  "required-mark": true,
                                  clearable: true,
                                  icon: "calendar",
                                  required: _vm.errorMessages.date,
                                  "required-condition": _vm.errorMessages.date,
                                },
                                model: {
                                  value: _vm.form.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "date", $$v)
                                  },
                                  expression: "form.date",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.id
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "fines-and-bonuses-create-modal__item w-260",
                            },
                            [
                              _c("c-input", {
                                attrs: {
                                  type: "select",
                                  "floating-label": "Выписал",
                                  clearable: true,
                                  searchable: true,
                                  items: _vm.collections.workers,
                                },
                                model: {
                                  value: _vm.form.addedBy,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "addedBy", $$v)
                                  },
                                  expression: "form.addedBy",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  !_vm.id
                    ? _c(
                        "div",
                        { staticClass: "fines-and-bonuses-create-modal__row" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fines-and-bonuses-create-modal__item added-by-input w-235",
                            },
                            [
                              _c("c-input", {
                                class: {
                                  "required-field": _vm.errorMessages.filial,
                                },
                                attrs: {
                                  type: "select",
                                  "floating-label": "Филиал",
                                  clearable: true,
                                  searchable: true,
                                  items: _vm.collections.filials,
                                  "required-mark": true,
                                  required: _vm.errorMessages.filial,
                                  "required-condition":
                                    _vm.errorMessages.filial,
                                },
                                on: { clearInput: _vm.onFilialInputClear },
                                model: {
                                  value: _vm.form.filial,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "filial", $$v)
                                  },
                                  expression: "form.filial",
                                },
                              }),
                            ],
                            1
                          ),
                          !_vm.id
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "fines-and-bonuses-create-modal__item added-by-input w-260",
                                },
                                [
                                  _c("c-input", {
                                    attrs: {
                                      type: "select",
                                      "floating-label": "Должность",
                                      clearable: true,
                                      searchable: true,
                                      items: _vm.collections.positions,
                                    },
                                    model: {
                                      value: _vm.form.position,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "position", $$v)
                                      },
                                      expression: "form.position",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  !_vm.id
                    ? _c(
                        "div",
                        {
                          staticClass: "fines-and-bonuses-create-modal__row",
                          class: { "mb-0": _vm.createFineOrBonus === "bonus" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fines-and-bonuses-create-modal__item",
                            },
                            [
                              _c("c-input", {
                                ref: "workerInput",
                                class: {
                                  "required-field": _vm.errorMessages.worker,
                                },
                                attrs: {
                                  type: "select",
                                  "floating-label": "Сотрудник",
                                  clearable: true,
                                  searchable: true,
                                  items: _vm.workersByFilialOrByPosition,
                                  disabled:
                                    !_vm.form.filial && !_vm.form.position,
                                  "required-mark": true,
                                  required: _vm.errorMessages.worker,
                                  "required-condition":
                                    _vm.errorMessages.worker,
                                },
                                model: {
                                  value: _vm.form.worker,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "worker", $$v)
                                  },
                                  expression: "form.worker",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.id && _vm.createFineOrBonus !== "bonus"
                    ? _c(
                        "div",
                        {
                          staticClass: "fines-and-bonuses-create-modal__row",
                          class: { "mb-0": !_vm.form.isExplanatoryRequired },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fines-and-bonuses-create-modal__item",
                              class: {
                                "mb-0": !_vm.form.isExplanatoryRequired,
                              },
                            },
                            [
                              _c("c-checkbox", {
                                attrs: {
                                  label:
                                    "Обязательно заполнение объяснительной",
                                },
                                model: {
                                  value: _vm.form.isExplanatoryRequired,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "isExplanatoryRequired",
                                      $$v
                                    )
                                  },
                                  expression: "form.isExplanatoryRequired",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.form.isExplanatoryRequired && !_vm.id
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "fines-and-bonuses-create-modal__row mb-0",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "fines-and-bonuses-create-modal__item date-input deadline-input mb-0",
                              },
                              [
                                _c("c-input", {
                                  class: {
                                    "required-field":
                                      _vm.errorMessages.deadline,
                                  },
                                  attrs: {
                                    type: "date",
                                    placeholder: "00.00.0000",
                                    label: "Ответ к дате",
                                    icon: "calendar",
                                    clearable: true,
                                    "icon-right": true,
                                    "required-mark": true,
                                    required: _vm.errorMessages.deadline,
                                    "required-condition":
                                      _vm.errorMessages.deadline,
                                  },
                                  model: {
                                    value: _vm.form.deadline,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "deadline", $$v)
                                    },
                                    expression: "form.deadline",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "fines-and-bonuses-create-modal__row" },
                    [
                      _c(
                        "div",
                        { staticClass: "fines-and-bonuses-create-modal__item" },
                        [
                          _c("c-input", {
                            ref: "comment",
                            attrs: {
                              type: "textarea",
                              "floating-label": "Комментарий",
                              clearable: true,
                              "max-length": "255",
                            },
                            model: {
                              value: _vm.form.comment,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "comment", $$v)
                              },
                              expression: "form.comment",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "fines-and-bonuses-create-modal__actions" },
                    [
                      _c("responsive-apply-reset-actions", {
                        attrs: {
                          fixed: !!!_vm.id,
                          "disabled-but-clickable-submit": _vm.isSubmitDisabled,
                        },
                        on: {
                          "on-submit": _vm.onSubmit,
                          "on-reset": _vm.onReset,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }